/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubmitMenuOrderResponse
 */
export interface SubmitMenuOrderResponse {
    /**
     * URL to redirect the user to complete payment
     * @type {string}
     * @memberof SubmitMenuOrderResponse
     */
    checkoutUrl: string;
}

/**
 * Check if a given object implements the SubmitMenuOrderResponse interface.
 */
export function instanceOfSubmitMenuOrderResponse(value: object): value is SubmitMenuOrderResponse {
    if (!('checkoutUrl' in value) || value['checkoutUrl'] === undefined) return false;
    return true;
}

export function SubmitMenuOrderResponseFromJSON(json: any): SubmitMenuOrderResponse {
    return SubmitMenuOrderResponseFromJSONTyped(json, false);
}

export function SubmitMenuOrderResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitMenuOrderResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'checkoutUrl': json['checkoutUrl'],
    };
}

export function SubmitMenuOrderResponseToJSON(json: any): SubmitMenuOrderResponse {
    return SubmitMenuOrderResponseToJSONTyped(json, false);
}

export function SubmitMenuOrderResponseToJSONTyped(value?: SubmitMenuOrderResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'checkoutUrl': value['checkoutUrl'],
    };
}

